import Avatar from '@mui/material/Avatar';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const Message = ({ full_name, text, formatted_date, error=true }) => {
    return (
        <div className="flex w-full gap-3 mt-5">
            <div>
                <Avatar
                    className="uppercase"
                    sx={{
                        width: 35,
                        height: 35,
                        backgroundColor: full_name === "Asistente" ? "#F4F5F7" : "#F4F5F7",
                        fontSize: 16,
                        color: "#000000",
                    }}
                    >
                    {full_name === "Asistente" ? (
                        <SmartToyIcon sx={{ fontSize: 20 }} />
                    ) : (
                        full_name
                        ?.split(" ")
                        .slice(0, 2)
                        .map((word) => word[0])
                        .join("") || "U"
                    )}
                </Avatar>
            </div>

            <div className="w-full">
                <label className="text-lg text-[#000000] font-medium capitalize">{full_name || "User"}</label>
                <label className="text-sm text-gray-500 ml-3 font-light">{formatted_date || ""}</label>

                <div className="text-base text-[#000000] font-light prose prose-sm max-w-none">
                    <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                            table: ({ node, ...props }) => (
                                <div className="overflow-x-auto my-2">
                                    <table className="min-w-full border border-gray-200 text-sm" {...props} />
                                </div>
                            ),
                            th: ({ node, ...props }) => (
                                <th className="border border-gray-200 px-3 py-2 bg-gray-50 text-left font-medium" {...props} />
                            ),
                            td: ({ node, ...props }) => (
                                <td className="border border-gray-200 px-3 py-2" {...props} />
                            ),
                            ul: ({ node, ...props }) => (
                                <ul className="list-disc list-inside my-1 space-y-1" {...props} />
                            ),
                            ol: ({ node, ...props }) => (
                                <ol className="list-decimal list-inside my-1 space-y-1" {...props} />
                            ),
                            h2: ({ node, children, ...props }) => (
                                <h2 className="text-base font-semibold mt-3 mb-1" {...props}>{children}</h2>
                            ),
                            h3: ({ node, children, ...props }) => (
                                <h3 className="text-sm font-semibold mt-2 mb-1" {...props}>{children}</h3>
                            ),
                            strong: ({ node, ...props }) => (
                                <strong className="font-semibold" {...props} />
                            ),
                        }}
                    >
                        {text}
                    </ReactMarkdown>
                </div>
            </div>
        </div>
    );
  };

export default Message;